/**
 * @package framework
 */
export default class SwagSecurityState {
    isActive(ticket) {
        return Shopware.Store.get('context').app.config.swagSecurity.includes(ticket);
    }
}
